<div class="footer_container">

    
    <div class="line_1">
        <img src="./../../../assets/frontend_logo.png" class="frontend_logo" id="frontend_logo">

        <span>&#169; Sangeethan 2025</span>

        <div class="icons_footer">
            <a href="https://github.com/SangeethanL/" target="_blank">
                <img src="./../../../assets/contact/github.png">
            </a>
            <a (click)="goToContact()">
                <img src="./../../../assets/contact/mail.png">
            </a>

        </div>
    </div>

    <div class="line_2">
        <div class="placeholder_line_2"></div>

        <a routerLink="/imprint" id="imprint">Impressum</a>

        <div class="icons_footer">
            <span id="angular">Diese Seite wurde mit Angular erstellt</span>
        </div>
    </div>


</div>